import { render, staticRenderFns } from "./PageRouter.html?vue&type=template&id=68191170&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./PageRouter.scss?vue&type=style&index=0&id=68191170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68191170",
  null
  
)

export default component.exports